import { render, staticRenderFns } from "./OrdersListView.vue?vue&type=template&id=611921e7&"
import script from "./OrdersListView.vue?vue&type=script&lang=js&"
export * from "./OrdersListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports